import { render, staticRenderFns } from "./generic-webform.vue?vue&type=template&id=7c1d7e06&scoped=true"
import script from "./generic-webform.vue?vue&type=script&lang=js"
export * from "./generic-webform.vue?vue&type=script&lang=js"
import style0 from "./generic-webform.vue?vue&type=style&index=0&id=7c1d7e06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d7e06",
  null
  
)

export default component.exports